<template>
    <div>
        <div class="row mb-3">
            <label for="emergency_service_type" class="col-md-3 col-form-label text-md-end">
                {{ label }} <span v-if="required" class="text-danger">*</span>
            </label>
            <div class="col-md-6">
                <select
                    id="emergency_service_type"
                    :name="name"
                    class="form-control"
                    :class="{ 'is-invalid': error }"
                    v-model="selectedType"
                    :required="required"
                >
                    <option value="">{{ selectText }}</option>
                    <option
                        v-for="(optionLabel, value) in options"
                        :key="value"
                        :value="value"
                    >
                        {{ optionLabel }}
                    </option>
                </select>
                <div v-if="error" class="invalid-feedback">{{ error }}</div>
            </div>
        </div>

        <div v-show="selectedType === 'other'" class="row mb-3">
            <label for="emergency_service_type_other" class="col-md-3 col-form-label text-md-end">
                {{ otherLabel }} <span class="text-danger">*</span>
            </label>
            <div class="col-md-6">
                <input
                    id="emergency_service_type_other"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': otherError }"
                    :name="otherName"
                    v-model="otherTypeValue"
                    :required="selectedType === 'other'"
                >
                <div v-if="otherError" class="invalid-feedback">{{ otherError }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EmergencyServiceTypeSelect',
    props: {
        name: {
            type: String,
            default: 'emergency_service_type'
        },
        otherName: {
            type: String,
            default: 'emergency_service_type_other'
        },
        label: {
            type: String,
            required: true
        },
        otherLabel: {
            type: String,
            required: true
        },
        selectText: {
            type: String,
            required: true
        },
        options: {
            type: Object,
            required: true
        },
        oldValue: {
            type: String,
            default: ''
        },
        oldOtherValue: {
            type: String,
            default: ''
        },
        error: {
            type: String,
            default: ''
        },
        otherError: {
            type: String,
            default: ''
        },
        required: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectedType: this.oldValue,
            otherTypeValue: this.oldOtherValue
        }
    },
    watch: {
        selectedType(newValue) {
            if (newValue !== 'other') {
                this.otherTypeValue = '';
            }
        }
    }
}
</script>
